import { render, staticRenderFns } from "./app-link.vue?vue&type=template&id=850a2e2e"
import script from "./app-link.vue?vue&type=script&lang=ts"
export * from "./app-link.vue?vue&type=script&lang=ts"
import style0 from "./app-link.vue?vue&type=style&index=0&id=850a2e2e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('850a2e2e')) {
      api.createRecord('850a2e2e', component.options)
    } else {
      api.reload('850a2e2e', component.options)
    }
    module.hot.accept("./app-link.vue?vue&type=template&id=850a2e2e", function () {
      api.rerender('850a2e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-link/app-link.vue"
export default component.exports